import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/HomePage";
import AboutUs from "../pages/AboutUs";
import Services from "../pages/Services";
import Blogs from "../pages/Blogs";
import Blog_Detail from "../pages/Blog_Detail";
import Events from "../pages/Events";
import Event_Detail from "../pages/Event_Detail";
import Contact_Us from "../pages/Contact_Us";
import Privecy from "../pages/Privecy";
import Condition from "../pages/Condition";

export class RouteApp extends Component {
  render() {
    return (
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<Blog_Detail />} /> 
        <Route path="/events" element={<Events />} />
        <Route path="/events/:slug" element={<Event_Detail />} />
        <Route path="/Contact_Us" element={<Contact_Us />} />
        <Route path="/privacy" element={<Privecy />} />
        <Route path="/condition" element={<Condition />} />
      </Routes>
    );
  }
}

export default RouteApp;
